(function() {
    'use strict';

    angular.module("page")
        .controller('PageUpdateController', PageUpdateController);

    PageUpdateController.$inject = ['$state', 'pageDataSrvc', 'pageSrvc', 'pageMessagesConst', 'notificationSrvc', 'lodashService', 'errorNotificationSrvc'];

    function PageUpdateController($state, pageDataSrvc, pageSrvc, pageMessagesConst, notificationSrvc, lodashService, errorNotificationSrvc) {
        var self = this;

        self.loading = true;

        self.serverErrors = {
            url_pl: [],
            url_de: [],
            url_en: [],
            url_cpde: [],
            url_cpen: [],
            title_seo_pl: [],
            title_seo_de: [],
            title_seo_en: [],
            title_seo_cpde: [],
            title_seo_cpen: [],
            description_seo_pl: [],
            description_seo_de: [],
            description_seo_en: [],
            description_seo_cpde: [],
            description_seo_cpen: [],
            keywords_seo_pl: [],
            keywords_seo_de: [],
            keywords_seo_en: [],
            keywords_seo_cpde: [],
            keywords_seo_cpen: [],
            type: [],
            menu: [],
            in_sitemap: [],
            publication_date: [],
            layout: [],
            first_col_content_pl: [],
            second_col_content_pl: [],
            third_col_content_pl: [],
            first_col_content_de: [],
            second_col_content_de: [],
            third_col_content_de: [],
            first_col_content_en: [],
            second_col_content_en: [],
            third_col_content_en: [],
            first_col_content_cpde: [],
            second_col_content_cpde: [],
            third_col_content_cpde: [],
            first_col_content_cpen: [],
            second_col_content_cpen: [],
            third_col_content_cpen: []
        };

        self.subpageOpts = {
            count: undefined,
            page: 1
        };

        self.subpageRows = [];
        self.subpageCols = [{
            title: 'Adres strony',
            value: 'url',
            type: 'text',
        }, {
            title: 'Tytuł',
            value: 'title_seo',
            type: 'text',
        }, {
            title: 'Typ',
            value: 'type',
            type: 'text',
        }, {
            title: 'Menu',
            value: 'menu',
            type: 'text',
        }];

        self.pageData = {};
        self.menuOptions = [];
        self.typeOptions = [];
        self.layoutOptions = [];
        self.layoutOptionsClasses = null;

        self.updatePage = updatePage;
        self.cleanErrors = cleanErrors;

        self.onSubpageCreate = onSubpageCreate;
        self.onSubpageEdit = onSubpageEdit;
        self.onSubpageDelete = onSubpageDelete;
        self.onReorder = onReorder;

        activate();

        function activate() {
            getPage();
            getMenuOptions();
            getTypeOptions();
            getLayoutOptions();
            getLayoutOptionsClasses();
        }

        function getPage() {
            self.loading = true;

            return pageDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(
                function(response) {
                    self.pageData = response;
                    self.subpageRows = response.subpages;
                    return response;
                }
            ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function updatePage() {
            return pageDataSrvc.update({
                pk: self.pageData.pk
            }, self.pageData).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", pageMessagesConst.update);
                    $state.go('layout.page.list');
                    return response;
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function getMenuOptions() {
            return pageDataSrvc.menuOptions().$promise.then(
                function(response) {
                    self.menuOptions = response;
                    self.pageData.menu = self.menuOptions[0][0];
                    return response;
                }
            );
        }

        function getTypeOptions() {
            return pageDataSrvc.typeOptions().$promise.then(
                function(response) {
                    self.typeOptions = response;
                    self.pageData.type = self.typeOptions[0][0];
                    return response;
                }
            );
        }

        function getLayoutOptions() {
            return pageDataSrvc.layoutOptions().$promise.then(
                function(response) {
                    self.layoutOptions = response;
                    return response;
                }
            );
        }

        function getLayoutOptionsClasses() {
            return pageDataSrvc.layoutOptionsClasses().$promise.then(
                function(response) {
                    self.layoutOptionsClasses = response;
                    return response;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }

        function onSubpageCreate() {
            $state.go('layout.page.create', { parent: self.pageData.pk });
        }

        function onSubpageEdit(row) {
            $state.go('layout.page.update', { pk: row.pk });
        }

        function onSubpageDelete(row) {
            return pageSrvc.remove(row.title_seo, row.pk, function(response) {
                notificationSrvc.notification("success", pageMessagesConst.delete);
                lodashService.remove(self.subpageRows, { pk: row.pk });
                return response;
            });
        }
        function onReorder(row, newPos) {
            return pageDataSrvc.update({
                pk: row.pk
            }, {
                subpage_position: newPos
            }).$promise.then(
                function(response) {
                    return response;
                },
                function(response) {
                    notificationSrvc.notification("error", pageMessagesConst.error);
                }
            );
        }
    }
})();
